import Grid from "@mui/material/Grid";
import React, {useState} from "react";
import Tab from "@mui/material/Tab";
import Tabs from "@mui/material/Tabs";

const Filters = ({filterNames, onFilterChange}) => {

    const [value, setValue] = useState(0);

    const handleButtonClick = (filter) => {
        onFilterChange(filter);
    };


    function a11yProps(index) {
        return {
            id: `simple-tab-${index}`,
            'aria-controls': `simple-tabpanel-${index}`,
        };
    }

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    return (
        <div style={{marginTop: '20px', marginBottom: '20px'}}>
            <Grid container direction={"row"} justifyContent={"flex-start"} alignContent={"center"}>
                <Grid item xs={12}>
                    <Tabs
                        indicatorColor="primary" // Set the indicator color to primary
                        sx={{
                            '& .MuiTabs-indicator': {
                                backgroundColor: '#FF6600', // Set the indicator color to FF6600
                            },
                            '& .Mui-selected': {
                                color: '#FF6600 !important', // Set the text color of the active tab
                            },
                        }}
                        textColor={'inherit'}
                        left
                        value={value}
                        onChange={handleChange}
                    >
                        {filterNames.map((name, index) => (
                            <Tab
                                className="h3"
                                style={{fontFamily:"Michroma", overflow: "none"}}
                                key={index}
                                label={name}
                                onClick={() => handleButtonClick(index)}
                                {...a11yProps(index)}
                            />
                        ))}
                    </Tabs>
                </Grid>
            </Grid>
        </div>
    )

}

export default Filters;